import { render, staticRenderFns } from "./CustomerBilling.vue?vue&type=template&id=c6e8ede8&scoped=true&"
import script from "./CustomerBilling.vue?vue&type=script&lang=js&"
export * from "./CustomerBilling.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBilling.vue?vue&type=style&index=0&id=c6e8ede8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e8ede8",
  null
  
)

export default component.exports